theme.slideShowTabMenu = (function () {
  function Slider(e) {
    let slideshow = e.querySelector(".slideshow__wrapper"),
      id = e.getAttribute("id"),
      paginationSelector = e.querySelector(".swiper-pagination"),
      navselectorPrev = e.querySelector(".swiper-button-prev"),
      navselectorNext = e.querySelector(".swiper-button-next"),
      autoplaySelctor = e.dataset.sliderAutoplay,
      autoplayInit = false,
      autoPlayDelay = parseInt(e.dataset.sliderDelay),
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      slidePagination = e.dataset.pagination,
      slideAnimation = e.dataset.sliderAnimation,
      paginatinInit = "bullets";

    if (loopSelector == "true") {
      loopInit = true;
    }
    if (slidePagination == "counter") {
      paginatinInit = "fraction";
    }

    const swiperContentSelector = document.querySelector(
      `#${id} .slideshow__contents-wrapper`
    );
    const swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
    const swiperTextElement = document.querySelector(swiperTextSelector);

    const swiperText = new Swiper(swiperTextSelector, {
      spaceBetween: 24,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true, // important!
      allowTouchMove: true,
      on: {
        init: function () {
          swiperTextElement.classList.add("first_step");
        },
        slideChange: function () {
          swiperTextElement.classList.remove("first_step");
        },
      },
    });

    const swiperImage = new Swiper(swiperContentSelector, {
      loop: loopInit,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      autoplay:
        autoplaySelctor == "true"
          ? {
              delay: autoPlayDelay || 5000,
              disableOnInteraction: false,
            }
          : false,
      autoHeight: false,
      speed: slideAnimation == "fade" ? 300 : 1000,
      effect: slideAnimation,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      thumbs: {
        swiper: swiperText,
      },
      fadeEffect: {
        crossFade: true,
      },
    });

    // Handle slide click fallback (for RTL fix)
    swiperText.on("click", function () {
      if (swiperText.clickedIndex !== undefined) {
        swiperImage.slideToLoop(swiperText.clickedIndex);
      }
    });

    // Add explicit click on tab items for better control
    const tabItems = swiperTextElement.querySelectorAll('.slideshow__tab');
    tabItems.forEach((tab, index) => {
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          swiperImage.slideToLoop(index);
          tab.focus();
        }
      });
    });

    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", function (event) {
        const block = event.target.closest("[data-block-id]");
        const blockId = block?.dataset?.blockId;

        if (!blockId) return;

        const allSlides = e.querySelectorAll(".slideshow__item-wrap");
        let targetIndex = Array.from(allSlides).findIndex(
          (slide) => slide.dataset.blockId === blockId
        );

        if (targetIndex >= 0) {
          swiperImage.slideTo(targetIndex);
          swiperText.slideTo(targetIndex);
        }
      });
    }
  }

  return Slider;
})();
